import { render, staticRenderFns } from "./SearchResultListOrdersToDispatch.vue?vue&type=template&id=7a639cea&scoped=true&"
import script from "./SearchResultListOrdersToDispatch.vue?vue&type=script&lang=js&"
export * from "./SearchResultListOrdersToDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a639cea",
  null
  
)

export default component.exports